<template>
  <div class="c-app flex-row align-items-center" id="login">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol col="12" lg="12">
          <CCard>
            <CCardBody>
              <h1 id="innder-logo">
                フォースタイル診断
                <span>- Personal Color -</span>
              </h1>
              <CRow class="justify-content-center">
                <CCol lg="6" xs="12" class="form-box border-right">
                  <CForm>
                    <h2>Login</h2>
                    <p class="fs12">アカウントにサインイン</p>
                    <CInput
                      placeholder="Email"
                      autocomplete="email"
                      class="email"
                      v-model="user.email">
                    </CInput>
                    <CInput
                      placeholder="Password"
                      type="password"
                      autocomplete="curent-password"
                      class="password"
                      v-model="user.password">
                    </CInput>
                    <CLink to="/app/color/forgot_password" class="px-0 fs12 ml40">パスワードが分からない場合はこちら</CLink>
                    <CRow>
                      <CCol col="12" class="text-center mt-4">
                        <CButton color="success" class="px-4 btn-login" @click="login()">Login</CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCol>
                <CCol lg="6" xs="12" class="form-box">
                  <h2>Sign up</h2>
                  <p class="fs12">アカウントをお持ちでない方はこちらからアカウントを作成ください。担当スタッフからご連絡をさせて頂きます。</p>
                  <p class="fs12">このツールは、for*styleパーソナルスタイリストスクールにて規定の講座を修了した人が利用できる、オンラインパーソナルカラー診断ツールです。講座受講中でアカウントをお持ちでない方は、こちらからアカウントを作成ください。折り返し担当スタッフからご連絡をさせて頂きます。講座を受講していない人がアカウント登録をすることはできません。</p>
                    <CRow>
                      <CCol col="12" class="text-center mt-4">
                        <CLink to="/app/color/register" class="fs20 font-weight-bold link-register">今すぐ登録！</CLink>
                      </CCol>
                    </CRow>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      user:{
        email:"",
        password:""
      },
    }
  },
  mounted: function () {
    localStorage.clear();
    this.env = APP_MODE;
  },
  methods: {
    login () {
      if(!this.user.email && !this.user.password){
        this.$swal('エラー', "メールアドレスとパスワードをご確認ください。", 'error');
      }else{
        let api = new ApiService();
        api.login(this.user)
          .then((response) => {
            if(response.status == 1){
              this.$swal('認証中', "スタッフによるユーザー確認を行っております。完了し次第メールにてお知らせ致しますので今暫くお待ち下さい。", 'info');
              return false;
            }
            if(response.status == 2){
              if(response.is_admin == 1){
                this.$router.push({path: "/app/color/users"});
              }else{
                this.$router.push({path: "/app/color/diagnosis"});
              }
            }
          })
          .catch((error) => {
            if(error.status == 401){
              this.$swal('エラー', "利用期限が終了しています、引き続き利用する場合はスタッフへお問い合わせください。", 'error');
            }else{
              this.$swal('エラー', "メールアドレスとパスワードをご確認ください。", 'error');
            }
          });
      }
    },
  }
}
</script>
